<template>
  <yandex-map
      :coords="coords"
      :controls="controls"
      :zoom="zoom"
      :cluster-options="{
        1: {
          clusterDisableClickZoom: false,
          hasBalloon: false
        }
      }"
  >
    <ymap-marker
        v-for="(placemark) in placemarks"
        :marker-id="placemark.node.nid"
        marker-type="placemark"
        :coords="placemark.coords"
        :icon="{color: placemark.node.placemark_color, glyph: 'christian'}"
        :key="placemark.node.nid"
        :hint-content="placemark.node.title"
        :callbacks="{click() { clickMarker(placemark) }}"
        :balloon-template="openBalloon(placemark)"
        cluster-name="1"
    ></ymap-marker>
  </yandex-map>
</template>
<script>
  export default {
    name: 'yandex-maps',
    props: {
      placemarks: {
        type: Array,
        required: true,
      },
      coords: {
        type: Array,
        required: true,
      },
      controls: {
        type: Array,
        required: true,
      },
      zoom: {
        type: Number,
        default: 12,
        required: true,
      },
    },
    computed: {
    },
    methods: {
      clickMarker (placemark) {
        this.$emit('click-marker', placemark);
      },
      openBalloon(placemark) {
        return `
          <div class="baloon-wrapper">
            <h3>${placemark.node.title}</h3>
            <p class="city">${placemark.node.field_diocese_city}</p>
            <p class="image"><img src="${placemark.node.field_media_image}"></p>
          </div>
        `;
      }
    },
  };
</script>
<style>

  .baloon-wrapper {
    width: 220px;
  }

  .baloon-wrapper h3 {
    margin-bottom: 0;
  }

  .baloon-wrapper p.city {
    margin-top: 0;
    font-size: 12px;
    color: #999999;
  }

  .baloon-wrapper p.image {
    margin: 0;
  }

  .baloon-wrapper img {
    max-width: 100%;
  }

</style>